import React, { useCallback, useEffect, useState } from "react";
import IconFont from "@/components/icon";
import "./index.less";
import {
  UploadControl,
  GroupUploadControlCenterInstance,
  groupJoyspaceKey
} from "@/components/Joyspace/components/GroupUploadPanel/UploadController";
import { Popover, Tooltip, message } from "antd";
import GroupSpaceDownloadController from "@/components/Joyspace/components/GroupDownloadPanel/BatchDownloadController";
import { getGlobalStatusText } from "@/components/Joyspace/components/BatchDownloadPanel/BasisComponents/utils";
import {
  GlobalBtnStatus,
  GlobalStatus
} from "@/components/Joyspace/components/BatchDownloadPanel/type";
import { TaskState } from "@/components/UploadBox/types";
import { useTranslation } from "@/components/Joyspace/context";
import events from "@/components/Joyspace/context/events";
import hidePopover from "@/assets/img/hidePopover.png";

interface IProps {
  gid: string;
  t: any;
  openGroupDrawer: () => void;
  crossAppStyle: any;
}
function GroupSpaces(props: IProps) {
  const { t, openGroupDrawer, gid, crossAppStyle } = props;
  const [uploadControlInstance, setUploadControlInstance] = useState<UploadControl | null>();
  const [
    downloadControlInstance,
    setDownloadControlInstance
  ] = useState<GroupSpaceDownloadController | null>();
  const [uploadInfo, setUploadInfo] = useState<any>(null); // 上传数据
  const [downlaodInfo, setDownlaodInfo] = useState<any>(null); // 下载数据
  const [visibleTask, setVisibleTaskPopover] = useState(false);
  const lang = useTranslation();
  const downloadControlEventListener = useCallback(() => {
    if (downloadControlInstance) {
      const state = downloadControlInstance.getGidByStateInfo(gid);
      setDownlaodInfo(state);
    }
  }, [downloadControlInstance, gid]);
  useEffect(() => {
    if (!downloadControlInstance) {
      setDownloadControlInstance(GroupSpaceDownloadController.getInstance());
      return;
    }
    const state = downloadControlInstance.getGidByStateInfo(gid);
    setDownlaodInfo(state);
    // onClose();
    downloadControlInstance?.on("group-download-control-event", downloadControlEventListener);
    return () => {
      downloadControlInstance?.off("group-download-control-event", downloadControlEventListener);
    };
  }, [downloadControlEventListener, downloadControlInstance, gid]);
  // end
  // 上传start
  const errorControlEventListener = useCallback((errMsg) => {
    const { errCode } = errMsg;
    // if (errCode === 'zeroSize') {
    // }
  }, []);
  const uploadControlEventListener = useCallback(
    ({ fileIds }: { fileIds: string[] }) => {
      if (uploadControlInstance) {
        const state = uploadControlInstance.getGidByStateInfo(gid);
        setUploadInfo(state);
      }
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [uploadControlInstance, gid]
  );
  useEffect(() => {
    // setVisibleTaskPopover(true);
    if (!uploadControlInstance) {
      setUploadControlInstance(
        GroupUploadControlCenterInstance.register(groupJoyspaceKey, true, gid)
      );
      return;
    }
    const state = uploadControlInstance.getGidByStateInfo(gid);
    setUploadInfo(state);
    // onClose();
    uploadControlInstance?.on("group-upload-control-event", uploadControlEventListener);
    uploadControlInstance?.on("group-upload-control-state-event", uploadControlEventListener);
    uploadControlInstance?.on("group-error-control-event", errorControlEventListener);
    return () => {
      uploadControlInstance?.off("group-upload-control-state-event", uploadControlEventListener);
      uploadControlInstance?.off("group-upload-control-event", uploadControlEventListener);
      uploadControlInstance?.off("group-error-control-event", errorControlEventListener);
    };
  }, [errorControlEventListener, uploadControlEventListener, uploadControlInstance, gid]);
  // end
  const onClose = useCallback(() => {
    let uploadState: any = uploadControlInstance?.getGidByStateInfo(gid) || [];
    let downloadState: any = downloadControlInstance?.getGidByStateInfo(gid) || [];
    if (downloadState?.totalCount && downloadState?.status !== GlobalStatus.PROGRESS_ALL) {
      downloadControlInstance?.clearGidByTask(gid);
    }
    if (
      uploadState?.totalCount &&
      uploadState?.status !== TaskState.UPLOADING &&
      uploadState?.status !== TaskState.PENDING
    ) {
      uploadControlInstance?.clearGidByAllUpload(gid);
    }
    setVisibleTaskPopover(false);
    if (
      downloadState?.status === GlobalStatus.PROGRESS_ALL ||
      uploadState?.status === TaskState.UPLOADING ||
      uploadState?.status === TaskState.PENDING
    ) {
      setVisibleTaskPopover(true);
      message.info("您有文件正在上传/下载，可在群空间入口处查看");
    }
    // setDownlaodInfo(downloadState);
    // setUploadInfo(uploadState);
    if (uploadState.totalCount) {
      uploadControlInstance?.off("group-upload-control-state-event", uploadControlEventListener);
      uploadControlInstance?.off("group-upload-control-event", uploadControlEventListener);
      uploadControlInstance?.off("group-error-control-event", errorControlEventListener);
      uploadControlInstance?.on("group-upload-control-event", uploadControlEventListener);
      uploadControlInstance?.on("group-upload-control-state-event", uploadControlEventListener);
      uploadControlInstance?.on("group-error-control-event", errorControlEventListener);
    }
    if (downloadState.totalCount) {
      downloadControlInstance?.off("group-download-control-event", downloadControlEventListener);
      downloadControlInstance?.on("group-download-control-event", downloadControlEventListener);
    }
  }, [
    downloadControlEventListener,
    downloadControlInstance,
    errorControlEventListener,
    gid,
    uploadControlEventListener,
    uploadControlInstance
  ]);
  useEffect(() => {
    events.on("joyspace.groupSpace:close", onClose);
    return () => {
      events.removeListener("joyspace.groupSpace:close", onClose);
    };
  }, [onClose]);
  useEffect(() => {
    if (!!downlaodInfo?.totalCount || !!uploadInfo?.totalCount) {
      setVisibleTaskPopover(true);
    }
    // if (
    //     downlaodInfo?.status === GlobalStatus.PROGRESS_ALL ||
    //     uploadInfo?.status === TaskState.UPLOADING ||
    //     uploadInfo?.status === TaskState.PENDING
    // ) {
    //     setVisibleTaskPopover(true);
    // }
  }, [downlaodInfo, uploadInfo]);
  const groupSpaceButton = useCallback(() => {
    return (
      <div className="group-session-header-toolbar-item" onClick={() => {
        openGroupDrawer?.();
      }}>
        <IconFont
          style={{ color: "#FFC300" }}
          type="iconqunwenjian"
        />
        群空间</div>
      // <div
      //   className="create_meeting no-draggable"
      //   onClick={() => {
      //     openGroupDrawer?.();
      //   }}
      //   style={crossAppStyle}
      // >
      //   <IconFont type="iconpc_im_zkj_jingban" />
      // </div>
    );
  }, [crossAppStyle, openGroupDrawer]);
  const content = useCallback(() => {
    let upload = null;
    let downlaod = null;
    if (downlaodInfo.totalCount > 0) {
      const statusText = getGlobalStatusText(downlaodInfo.status);
      const currentCountStr =
        downlaodInfo.status === GlobalStatus.PROGRESS_ALL
          ? `${downlaodInfo.currentCount}/${downlaodInfo.totalCount}`
          : "";
      downlaod = (
        <>
          {statusText}
          {currentCountStr}
        </>
      );
    }
    const { status, stateCount, currentCount, totalCount } = uploadInfo;
    if (totalCount > 0) {
      const headerText: any = {
        [TaskState.UPLOADING]: lang("myspace.upload_uploading"),
        [TaskState.PENDING]: lang("myspace.upload_uploading"),
        [TaskState.COMPLETED]: lang("myspace.upload_success"),
        [TaskState.FAILED]: lang("myspace.upload_failed"),
        [TaskState.CANCEL]: lang("myspace.upload_cancelled")
      };
      let statusText = headerText[status];
      if (
        stateCount !== totalCount &&
        status !== TaskState.PENDING &&
        status !== TaskState.UPLOADING
      ) {
        statusText = `部分${statusText}`;
      } else if (
        stateCount === totalCount &&
        status !== TaskState.PENDING &&
        status !== TaskState.UPLOADING
      ) {
        statusText = `全部${statusText}`;
      }
      const currentCountStr = status === TaskState.UPLOADING ? `${currentCount}/${totalCount}` : "";
      upload = (
        <>
          {statusText}
          {currentCountStr}
          {downlaodInfo.totalCount > 0 ? "；" : ""}
        </>
      );
    }
    return (
      <div className="group-spaces-info">
        {upload}
        {downlaod}
        <img
          onClick={() => {
            setVisibleTaskPopover(false);
            uploadControlInstance?.off(
              "group-upload-control-state-event",
              uploadControlEventListener
            );
            uploadControlInstance?.off("group-upload-control-event", uploadControlEventListener);
            uploadControlInstance?.off("group-error-control-event", errorControlEventListener);
            downloadControlInstance?.off(
              "group-download-control-event",
              downloadControlEventListener
            );
          }}
          src={hidePopover}
        />
      </div>
    );
  }, [
    downlaodInfo,
    uploadInfo,
    lang,
    uploadControlEventListener,
    errorControlEventListener,
    downloadControlEventListener,
    downloadControlInstance,
    uploadControlInstance
  ]);
  if ((uploadInfo?.totalCount || downlaodInfo?.totalCount) && visibleTask) {
    return (
      <Popover
        content={content}
        overlayClassName="group-spaces-popover"
        visible={visibleTask}
        title={false}
        placement="bottom"
      >
        {groupSpaceButton()}
      </Popover>
    );
  }
  const title = t("groupSpace");
  return (
    // <Tooltip title={title} overlayStyle={{ whiteSpace: "nowrap" }} placement="bottom">
      groupSpaceButton()
    // </Tooltip>
  );
}

export default GroupSpaces;
